import { Component, input, output, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormMode } from 'app/core/constants/form-mode';
import { ListCardComponent } from 'app/core/components/list-card/list-card.component';
import { AppSettings } from '@services/settings/app-settings.service';
import { formatVehiclePartList } from '../../../management-vehicle/vehicle-damage-selector/vehicle-damage-parts';
import { getDetailEvidenceProgress } from '../../utils/claim-details.util';

@Component({
  selector: 'app-claim-detail-list',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, DatePipe, ListCardComponent],
  templateUrl: './claim-detail-list.component.html',
  styleUrls: ['./claim-detail-list.component.css']
})
export class ClaimDetailListComponent {
  details = input<any[]>([]);
  mode = input<FormMode>(FormMode.VIEW);
  partyData = input<any>(null);
  isTotalLoss = input<boolean>(false);
  vehicleValue = input<number>(0);
  selectedVehicleType = input<string>('sedan');
  claimDocuments = input<any[]>([]);
  canCreate = input<boolean>(true);

  open = output<any>();
  create = output<void>();
  remove = output<number>();

  formMode = FormMode;
  appSettings = inject(AppSettings);

  affectedPartsLabel(det: any): string {
    return formatVehiclePartList(det?.affectedParts, this.selectedVehicleType());
  }

  statusLabel(det: any): string {
    return getDetailEvidenceProgress(det, this.claimDocuments()).label;
  }

  statusClass(det: any): string {
    return getDetailEvidenceProgress(det, this.claimDocuments()).badgeClass;
  }

  detailCost(det: any): number {
    if (det?.totalCost && det.totalCost > 0) return Number(det.totalCost);
    return this.isTotalLoss() ? this.vehicleValue() : 0;
  }

  isDriverParty(det: any): boolean {
    return det?.driverLicense === this.partyData()?.rut || !det?.driverLicense;
  }
}
